import { getAccessToken } from "../Services/authToken";

export interface CheckAlternateSlotsEmailSentPayload {
  email_type: string;
}

const hostname = window.location.hostname;

export async function CheckAlternateSlotsEmailSent(
  emailPayload: CheckAlternateSlotsEmailSentPayload
): Promise<any> {
  let baseurl = "";
  if (hostname.includes("localhost")) {
    baseurl = "http://localhost:8080";
  } else if (hostname.includes("dev")) {
    baseurl = "https://candidateinterviewscheduler-dev.pwc.com";
  } else if (hostname.includes("stg") || hostname.includes("stage")) {
    baseurl = "https://candidateinterviewscheduler-stg.pwc.com";
  } else {
    baseurl = "https://candidateinterviewscheduler.pwc.com"; // fallback
  }

  // GET TOKEN
  const token = await getAccessToken();
  if (!token) {
    throw new Error("Authentication required - please log in");
  }

  console.log(emailPayload)
  const res = await fetch(`${baseurl}/api/communications/emails`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(emailPayload),
  });

  // console.log("Email response:", res);

  let responseData = null;
  try {
    responseData = await res.json();
  } catch {
    responseData = await res.text();
  }

  if (!res.ok) {
    throw new Error(
      `No-slot email failed: ${res.status} ${res.statusText} ${responseData}`
    );
  }

  return responseData;
}
